import { Chapter } from './../../models';
import { EcomicService } from './../../service/comics/ecomic.service';
import { Component, OnInit } from '@angular/core';
import { AngularFirestore, AngularFirestoreCollection } from '@angular/fire/firestore';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';
declare const swal: any;
declare var $: any;
@Component({
  selector: 'app-e-novel-chapter',
  templateUrl: './e-novel-chapter.component.html',
  styleUrls: ['./e-novel-chapter.component.css']
})
export class ENovelChapterComponent implements OnInit {
  Enovelepisodecol: AngularFirestoreCollection<Chapter>;
  Enovelepisode: Observable<Chapter[]>;
  showseason: any = true;
  showseries: any = true;
  seasons: any;
  eseries: any;
  seasonoption: any = 'All';
  seriesoption: any = 'All';
  selectedseries: any = 'All';
  selectedseason: any = 'All';
  selectedstatus: any = 'All';
  id:any;
  constructor(private afs: AngularFirestore, private comicService: EcomicService) { }

  async ngOnInit() {
    this.showseries = false;
    const collection = await this.afs.collection('Enovelseries');
    await collection.valueChanges().subscribe(seriess => {
      this.eseries = seriess;
      if(this.eseries.length < 1) {this.seriesoption = ''; }
      this.showseries = true;
    });
    this.Enovelepisodecol = this.afs.collection('Enovelchapter',res=>{
      return res.orderBy('createdAt', 'desc')
    });
    this.Enovelepisode = this.Enovelepisodecol.valueChanges();
  }
  async getseasons(id) {
    id == 'All' ? this.selectedseason = 'All' : '';
    this.showseason = false;
    try {
      this.comicService.getnovelseasons(id).then(eseasonsdata => {
        // subscribing the data from the service
        eseasonsdata.subscribe(eseasons => {
          this.seasons = eseasons;
          this.seasonoption = this.seasons.length < 1 ? '' : 'All';
          this.showseason = true;
        });
      });
    } catch (error) {
      this.showseason = true;
      console.log(error);
    }
}
filterdata () {
  const type = this.selectedseries != 'All' ? 'novel_series' : 'status';
  const content = this.selectedseries != 'All' ? this.selectedseries : this.selectedstatus;
  console.log(this.selectedstatus,this.selectedseries, this.selectedseason)
  this.Enovelepisodecol = this.afs.collection('Enovelchapter', res => {
    if (this.selectedseason == 'All' && this.selectedseries == 'All' && this.selectedstatus == 'All') {
      return res.orderBy('createdAt', 'desc')
    } else if (this.selectedseason != 'All' && this.selectedseries != 'All' && this.selectedstatus != 'All') {
      console.log('fine');
      return res.orderBy('createdAt', 'desc').where('status', '==', this.selectedstatus)
                .where('novel_seasons', '==', this.selectedseason)
                .where('novel_series', '==', this.selectedseries);
    } else if (this.selectedstatus != 'All' && this.selectedseries != 'All') {
      return res.orderBy('createdAt', 'desc').where('status', '==', this.selectedstatus).where('novel_series', '==', this.selectedseries);
     } else if (this.selectedseason != 'All' && this.selectedseries != 'All') {
      return res.orderBy('createdAt', 'desc').where('novel_seasons', '==', this.selectedseason).where('novel_series', '==', this.selectedseries);
     } else {
      return res.orderBy('createdAt', 'desc').where(type, '==', content);
     }
  });
  this.Enovelepisode = this.Enovelepisodecol.valueChanges();
}

delete(id) {
  console.log(id);
  this.id = id;
  $("#DeleteModal").modal();
}
deletedata() {
  $('#DeleteModal').modal('hide');
    this.afs.doc('/Enovelchapter/'+this.id).delete().then(function () {  
      swal('Deleted!', 'Your List has been deleted.', 'success');
    }).catch(function(error){
      swal('Error!', error, 'error');
      console.error("error in removing document:",error);
    });
}



}



// WEBPACK FOOTER //
// ./src/app/E-novels/e-novel-chapter/e-novel-chapter.component.ts